import { render, staticRenderFns } from "./_Total_metas.vue?vue&type=template&id=16008d95&scoped=true&"
import script from "./_Total_metas.vue?vue&type=script&lang=js&"
export * from "./_Total_metas.vue?vue&type=script&lang=js&"
import style0 from "./_Total_metas.vue?vue&type=style&index=0&id=16008d95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16008d95",
  null
  
)

export default component.exports